module.exports = __webpack_public_path__ + "1_0_57/img/200 Big Ben.1dde82ee.jpg";